import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["categoryButtonContainer", "breadcrumb", "productItem"]
    static values = {
        categories: Array,
        i18n: Object // 新しく追加
    }

    connect() {
        this.updateView("all")
    }

    updateView(categoryId) {
        this.renderCategoryButtons(categoryId)
        this.renderBreadcrumb(categoryId)
        this.filterProductItems(categoryId)
    }

    selectCategory(event) {
        event.preventDefault()
        const categoryId = event.currentTarget.dataset.categoryId
        this.updateView(categoryId)
    }

    renderCategoryButtons(parentId) {
        this.categoryButtonContainerTarget.innerHTML = ""

        let categoriesToShow
        if (parentId === "all") {
            categoriesToShow = this.categoriesValue.filter(cat => !cat.ancestry)
        } else {
            categoriesToShow = this.categoriesValue.filter(cat => cat.ancestry == parentId)
        }

        if (parentId !== "all") {
            const parentCategory = this.categoriesValue.find(cat => cat.id == parentId)
            let backButtonHtml = `<button class="btn btn-outline-secondary me-2 mb-2" data-action="click->product-category#selectCategory" data-category-id="${parentCategory.ancestry || 'all'}">`
            backButtonHtml += `&#x2190; ${this.i18nValue.back_to_parent_category}`
            backButtonHtml += `</button>`
            this.categoryButtonContainerTarget.innerHTML += backButtonHtml
        }

        categoriesToShow.forEach(cat => {
            this.categoryButtonContainerTarget.innerHTML += `<button class="btn btn-outline-secondary category-filter-btn me-2 mb-2" data-action="click->product-category#selectCategory" data-category-id="${cat.id}" data-category-name="${cat.name}">${cat.name}</button>`
        })
    }

    renderBreadcrumb(categoryId) {
        this.breadcrumbTarget.innerHTML = ""

        const topText = this.i18nValue.top
        let breadcrumbHtml = `<ol class="breadcrumb">`
        if (categoryId === "all") {
            breadcrumbHtml += `<li class="breadcrumb-item active">${topText}</li>`
        } else {
            breadcrumbHtml += `<li class="breadcrumb-item"><a href="#" data-action="click->product-category#selectCategory" data-category-id="all">${topText}</a></li>`
        }

        if (categoryId !== "all") {
            let currentCategory = this.categoriesValue.find(cat => cat.id == categoryId)
            if (currentCategory) {
                const path = [currentCategory]
                while (currentCategory.ancestry) {
                    currentCategory = this.categoriesValue.find(cat => cat.id == currentCategory.ancestry)
                    if (currentCategory) {
                        path.unshift(currentCategory)
                    } else {
                        break
                    }
                }

                path.forEach((cat, index) => {
                    if (index === path.length - 1) {
                        breadcrumbHtml += `<li class="breadcrumb-item active">${cat.name}</li>`
                    } else {
                        breadcrumbHtml += `<li class="breadcrumb-item"><a href="#" data-action="click->product-category#selectCategory" data-category-id="${cat.id}">${cat.name}</a></li>`
                    }
                })
            }
        }

        breadcrumbHtml += `</ol>`
        this.breadcrumbTarget.innerHTML = breadcrumbHtml
    }

    filterProductItems(categoryId) {
        this.productItemTargets.forEach(item => {
            const itemCategoryIds = JSON.parse(item.dataset.categoryIds)
            // 🚀 修正: カテゴリー未設定（isCategorizedがfalse）かどうかを判定
            const isUncategorized = item.dataset.isCategorized === "false"

            if (categoryId === "all") {
                // 🚀 最初（All）の時は、カテゴリー未設定のものだけを表示
                if (isUncategorized) {
                    item.style.display = ""
                } else {
                    item.style.display = "none"
                }
            } else if (itemCategoryIds.includes(parseInt(categoryId))) {
                // 個別カテゴリー選択時は、そのカテゴリーに属するものを表示
                item.style.display = ""
            } else {
                item.style.display = "none"
            }
        })
    }    
}